import React, {
  FocusEvent,
  RefObject,
  KeyboardEvent,
} from 'react';
import clsx from 'clsx';
import MaskedTextField from 'components/common/MaskedTextField';
import { FieldComponentProps } from 'components/anvilFormFillable/fields/types';

const amountBlock = Object.freeze({
  mask: Number,
  thousandsSeparator: ',',
  scale: 2,
  normalizeZeros: true,
  padFractionalZeros: false,
  radix: '.',
  placeholderChar: '0',
});

const mask = Object.freeze([{
  mask: '$amount',
  lazy: false,
  overwrite: true,
  blocks: { amount: amountBlock },
}]);

type Props = FieldComponentProps & {
  id?: string;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  className?: string;
  inputProps?: object;
  inputRef?: RefObject<HTMLInputElement>;
  defaultValue?: string | number | null;
  nullIfEmpty?: boolean;
  allowNegative?: boolean;
  disabled?: boolean;
};

export default function CurrencyTextField({
  value,
  className,
  onChange,
  onKeyDown,
  defaultValue = '0',
  nullIfEmpty = false,
  allowNegative = false,
  disabled = false,
  ...props
}: Props) {
  const fieldMask = allowNegative
    ? mask
    : [{
      ...mask[0],
      blocks: {
        amount: {
          ...amountBlock,
          min: 0,
        },
      },
    }];

  return (
    <MaskedTextField
      {...props}
      unmask
      mask={fieldMask}
      defaultValue={defaultValue}
      autoFocus
      value={value?.value ?? ''}
      onAccept={(data: string) => {
        onChange?.({ ...value, value: data });
      }}
      disabled={disabled}
      onKeyDown={onKeyDown}
      className={clsx('border border-gray-100', className)}
    />
  );
}
